// src/components/sections/Testimonials/Testimonials.jsx
import React from 'react';
import { Star, MessageSquare } from 'feather-icons-react'; // Imported MessageSquare for the quote icon

// Updated testimonials array without the 'img' property
const testimonials = [
    {
        quote: "D Red Interiors transformed our outdated home into a modern masterpiece. Their attention to detail and ability to blend luxury with liveability is unmatched.",
        name: "Sravanthi",
        title: "Homeowner, Chennai",
    },
    {
        quote: "Our new office space has completely changed our company culture. The design is both functional, inspiring, and perfectly embodies our tech forward brand.",
        name: "Thiru Murugan",
        title: "Tech Startup CEO, Chennai",
    },
    {
        quote: "From concept to completion, D Red Interiors exceeded our expectations. Our restaurant is now the talk of the town—beautiful and highly functional.",
        name: "Kaushik",
        title: "Restaurant Owner, Chennai",
    },
];

// StarRating component remains the same, but using 'text-sm' on the gap
const StarRating = () => (
    <div className="text-primary mb-4 flex gap-x-1">
        {[...Array(5)].map((_, i) => (
            <Star key={i} className="inline fill-current h-5 w-5" />
        ))}
    </div>
);

const Testimonials = () => {
    return (
        <section className="py-24 sm:py-32 px-4 max-w-7xl mx-auto bg-light">
            {/* Header Section - Refined Typography */}
            <div className="text-center mb-16 md:mb-20">
                <h2 className="text-base font-semibold text-primary mb-3 uppercase tracking-widest font-heading">Client Voices</h2>
                <h3 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-heading text-secondary leading-tight mb-6">
                    What Our Clients Say
                </h3>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto">
                    Trust is the foundation of great design. Read their stories and discover the impact of true excellence.
                </p>
            </div>
            
            {/* Testimonials Grid - Dynamic Card Styles */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {testimonials.map((t, index) => (
                    // Testimonial Card - New distinct border, shadow, and hover animation
                    <div 
                        key={index} 
                        className="relative bg-white p-8 rounded-2xl shadow-xl 
                                   border-t-4 border-primary transition-all duration-500 ease-in-out 
                                   transform hover:shadow-2xl hover:scale-[1.03] hover:-translate-y-1 
                                   hover:bg-gray-50 cursor-pointer group"
                    >
                        
                        {/* Quote Icon - Large, transparent, and positioned for a visual accent */}
                        <MessageSquare 
                            className="absolute top-0 right-0 m-6 w-12 h-12 text-primary opacity-10 
                                       transition-opacity duration-500 ease-in-out group-hover:opacity-20" 
                            strokeWidth={1} 
                        />

                        <StarRating />
                        
                        {/* Quote Text - Enhanced styling */}
                        <p className="text-gray-800 mb-8 text-xl font-serif italic leading-relaxed relative">
                            {/* Added decorative quotation marks before the text */}
                            <span className="text-primary text-4xl font-bold absolute -left-4 -top-3 opacity-70">"</span>
                            {t.quote}
                        </p>
                        
                        {/* Client Info - Image block removed */}
                        <div className="pt-4 border-t border-gray-100">
                            <h4 className="font-extrabold text-lg text-secondary font-heading">
                                {t.name}
                            </h4>
                            <p className="text-primary text-sm font-medium">
                                {t.title}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;